/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{1B724B7C-EDB6-43BF-BC85-E5FB25179787}",
  "sitecoreApiHost": "https://pp-ws-cd.api.org/",
  "jssAppName": "webstore",
  "coveoAccessToken": "xxc10c31ce-be5c-45cd-a6a7-1cf9a7db4d78",
  "coveoOrganizationId": "americanpetroleuminstitutenonproduction10dx9nioc",
  "coveoFarmName": "",
  "coveoSearchHub": "Webstore",
  "coveoQueryPipeline": "API Webstore PP",
  "coveoSubscriptionPipeline": "API Webstore Subscription PP",
  "coveoSubscriptionProductSource": "@source==webstore-PP",
  "coveoSubscriptionProductFilter": "((@producttype==\\\"Standard\\\" @productcode==[[@productcode] @accountnumber==__ACCOUNTNUMBER__ @source==webstore-account-PP]) OR (@producttype==\\\"Standard\\\" @industrysegment @industrysegment==[[@productcode] @accountnumber==__ACCOUNTNUMBER__ @source==webstore-account-PP]) OR (@producttype==\\\"Datasheet\\\" @producttype==[[@productcode] @accountnumber==__ACCOUNTNUMBER__ @source==webstore-account-PP]))",
  "subscriptionKey": "2ccbc0e1717b49dfa7d0aebbfafdd583",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/sitecore/api/graph/edge",
  "webstoreVersion": "2024.06.13.12.43",
  "graphQLEndpoint": "https://pp-ws-cd.api.org//sitecore/api/graph/edge"
};